module.exports = __webpack_public_path__ + "media/images/grey_logos/today-61bb76bb7f8911e50b654448675629db.svg";